import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import Loading from './views/Loading'
import GettingStarted from './views/GettingStarted'
import PlantingTime from './views/PlantingTime'
import Goals from './views/Goals'
import Species from './views/Species'
import Inoculation from './views/Inoculation'
import Summary from './views/Summary'
import Contact from './views/Contact'
import Resume from './views/Resume'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/loading',
      name: 'loading',
      component: Loading
    },
    {
      path: '/start',
      name: 'getting-started',
      component: GettingStarted
    },
    {
      path: '/time',
      name: 'planting-time',
      component: PlantingTime
    },
    {
      path: '/goals',
      name: 'goals',
      component: Goals
    },
    {
      path: '/species',
      name: 'species',
      component: Species
    },
    {
      path: '/inoculation',
      name: 'inoculation',
      component: Inoculation
    },
    {
      path: '/summary',
      name: 'summary',
      component: Summary
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/resume/:id',
      name: 'resume',
      components: { default: Resume },
      props: { default: true }
    },
    {
      path: '/resume',
      redirect: '/'
    }
  ]
})
